/**
 * Composant d'affichage vide pour les réservations sans review
 * Accordion désactivé avec message explicatif
 */

import React from 'react';
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  alpha
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  RateReview as RateReviewIcon
} from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

/**
 * Composant OwnerReviewEmpty
 * Affiche un accordion désactivé quand aucune review n'existe
 */
const OwnerReviewEmpty = () => {
  const theme = useTheme();
  const { t } = useTranslation('ownerReviews');

  return (
    <Accordion
      disabled
      sx={{
        borderRadius: 2,
        border: `1px solid ${theme.palette.divider}`,
        backgroundColor: alpha(theme.palette.grey[500], 0.05),
        '&:before': {
          display: 'none'
        },
        '&.Mui-disabled': {
          backgroundColor: alpha(theme.palette.grey[500], 0.05)
        }
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          cursor: 'default',
          '& .MuiAccordionSummary-content': {
            alignItems: 'center',
            gap: 1
          }
        }}
      >
        <RateReviewIcon sx={{ color: theme.palette.grey[400] }} />
        <Typography variant="subtitle2" fontWeight={600} color="text.secondary">
          {t('empty.title')}
        </Typography>
      </AccordionSummary>

      <AccordionDetails>
        <Box sx={{ textAlign: 'center', py: 2 }}>
          <Typography variant="body2" color="text.secondary">
            {t('empty.message')}
          </Typography>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default OwnerReviewEmpty;
